namespace JupitersChoice {
    export class CheckFreeGameWinsCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _server: Sapphire.GameServer;

        execute(): void {
            const response: any = this._server.logicResponse;
            const currentFreeSpinInfo = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1];
            var hasWins = currentFreeSpinInfo.winnings && currentFreeSpinInfo.winnings.length > 0;

            if (!hasWins) {
                TweenMax.delayedCall(1.5, () => {
                    this._eventManager.publish('onHasNoFreeGameWins');
                });
            } else {
                this._eventManager.publish('onHasFreeGameWins');
            }
        }
    }
}